module.exports = __webpack_public_path__ + "software-cycle.1xTb47ea.svg";